import { Redirect } from "react-router-dom";

import Logout from "src/pages/Authentication/Logout";

import ForgotPassword from "src/pages/Authentication/ForgotPassword";
import Login from "src/pages/Authentication/Login";
import Register from "src/pages/Authentication/Register";
import ResetPassword from "src/pages/Authentication/ResetPassword";
import ResetPasswordSuccess from "src/pages/Authentication/ResetPasswordSuccess";

//table
import BasicTable from "src/pages/Tables/BasicTables";

import AdminHome from "src/pages/Dashboard/AdminHome";
import UserHome from "src/pages/Dashboard/UserHome";
import CreateModule from "src/pages/SuperAdmin/Modules/CreateModule";

import UsersManagment from "src/pages/SuperAdmin/UsersManagment/UsersManagment";


import RegisterSuccess from "src/pages/Authentication/RegisterSuccess";
import { EditProfile } from "src/pages/Profile/EditProfile";
import AllModules from "src/pages/SuperAdmin/Modules/AllModules";
import { EditField, EditModule, FieldsModule } from "src/pages/SuperAdmin/Modules/DropdownModule";
import { ActionsModule } from "src/pages/SuperAdmin/Modules/DropdownModule/Actions";
import CreateAction from "src/pages/SuperAdmin/Modules/DropdownModule/Actions/CreateAction";
import EditAction from "src/pages/SuperAdmin/Modules/DropdownModule/Actions/EditAction";
import CreateField from "src/pages/SuperAdmin/Modules/DropdownModule/Field/CreateField";
import { EditFieldSetting } from "src/pages/SuperAdmin/Organisations/ChildComponent/EditFieldSetting";
import EditOrganisation from "src/pages/SuperAdmin/Organisations/ChildComponent/EditOrganisation";
import FieldSetting from "src/pages/SuperAdmin/Organisations/ChildComponent/FieldSetting";
import CreateOrganisation from "src/pages/SuperAdmin/Organisations/CreateOrganisation";
import Organisations from "src/pages/SuperAdmin/Organisations/Organisations";
import CreateTicketSuperAdmin from "src/pages/SuperAdmin/TicketingSuperAdmin/CreateTicketSuperAdmin";
import TicketingSuperAdmin from "src/pages/SuperAdmin/TicketingSuperAdmin/TicketingSuperAdmin";
import { EditUsersManagment } from "src/pages/SuperAdmin/UsersManagment";
import CreateUser from "src/pages/SuperAdmin/UsersManagment/CreateUser";
import DynamicModules from "src/pages/Users/DynamicModules";
import { CreateTicket } from "src/pages/Users/Ticketing/CreateTicket";
import Ticketing from "src/pages/Users/Ticketing/Ticketing";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const adminRoutes: Array<RouteProps> = [
  //AppHeader
  { path: "/admin-edit-profile", component: EditProfile },
  { path: "/logout", component: Logout },

  //Admin sidebar
  { path: "/admin-home", component: AdminHome },
  { path: "/all-modules", component: AllModules },
  { path: "/tables-basic", component: BasicTable },

  //Module
  { path: "/create-module", component: CreateModule },
  { path: "/edit-module", component: EditModule },
  { path: "/fields-module", component: FieldsModule },
  { path: "/actions-module", component: ActionsModule },

  //Field
  { path: "/create-field", component: CreateField },
  { path: "/edit-field", component: EditField },

  //Actions 
  { path: "/create-action", component: CreateAction },
  { path: "/edit-action", component: EditAction },

  //User's Managment
  { path: "/users-managment", component: UsersManagment },
  { path: "/create-user", component: CreateUser },
  { path: "/edit-usersManagment", component: EditUsersManagment },

  //Ticketing
  { path: "/admin-ticketing", component: TicketingSuperAdmin },
  { path: "/admin-create-ticket", component: CreateTicketSuperAdmin },

  //Organisation
  { path: "/organisations", component: Organisations },
  { path: "/create-organisation", component: CreateOrganisation },
  { path: "/edit-organisation", component: EditOrganisation },
  { path: "/field-setting", component: FieldSetting },
  { path: "/edit-field-setting", component: EditFieldSetting },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/admin-ticketing" /> },
];

const userRoutes: Array<RouteProps> = [
  //AppHeader
  { path: "/user-edit-profile", component: EditProfile },
  { path: "/logout", component: Logout },

  //User sidebar
  { path: "/user-home", component: UserHome },

  //UsersModule
  { path: "/user-modules", component: DynamicModules },

  //Ticketing
  { path: "/ticketing", component: Ticketing },
  { path: "/create-ticket", component: CreateTicket },


  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/ticketing" /> },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/register-success", component: RegisterSuccess },
  { path: "/forgotPassword", component: ForgotPassword },
  { path: "/resetPassword", component: ResetPassword },
  { path: "/resetPasswordSuccess", component: ResetPasswordSuccess },
];

export { adminRoutes, authRoutes, userRoutes };

